import defaultUserProfile from "../../../../assets/restaurant/images/default_user_profile.png";

type RestaurantProfileAvatarProps = {
  src?: string;
  alt?: string;
  className?: string;
};

const RestaurantProfileAvatar = ({
  src,
  alt = "profile-img",
  className = "avatar avatar-xxs",
}: RestaurantProfileAvatarProps) => (
  <div className={`${className} restaurant-profile-avatar`.trim()}>
    <img
      src={src || defaultUserProfile}
      alt={alt}
      onError={(event) => {
        event.currentTarget.src = defaultUserProfile;
      }}
    />
  </div>
);

export default RestaurantProfileAvatar;
